import React from "react";

// Mui
import ProfitAndLossDetailTable from "@/components/DataTable/profitAndLossDetailTable";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
// Navigate

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { getProducts } from "@/fetch/fetchStatistics";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";
// Config

import ProfitAndLossToolBar from "@/components/DataTable/profitAndLossToolBar";
// Fetch
import { CurrencyFormat, toPercent } from "@/config/normalConfig";
import { setFilter } from "@/features/dataTableSlice";
import { getProfitAndLoss } from "@/fetch/fetchStatistics";
import { useCurrentAction } from "@/hooks/user";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import _ from "lodash";
const ProfitAndLossTablePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  // Navigate
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [rowData, setRowData] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [productData, setProductData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [detailDialogOpen, setDetailDialogOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({});
  const dateFilter = useSelector((state) => state.dataTable.dateFilter);

  const getRowId = (row) => {
    return row.product_master_id ?? row.brand_id;
  };
  const orders = [
    "region_name",
    "mannings_product_code",
    "m18_product_code",
    "product_name",
    "totalQty",
    "rrp",
    "scanSales",
    "margin",
    "tradeDiscount",
    "tradeDiscountToMargin",
    "promotionRebateTotal",
    "rebateToMargin",
    "revenue",
    "sumOfCommission",
    "commissionToMargin",
    "commissionToScan",
    "marketingTotalCost",
    "marketingToMargin",
    "marketingToScan",
    "profit",
  ];

  const initColumn = [];
  if (actions.qty) {
    initColumn.push({
      field: "totalQty",
      headerName: "Qty",
      type: "number",
      align: "right",
      headerAlign: "right",
      valueFormatter: (value) => `${new Intl.NumberFormat().format(value)}`,
    });
  }
  if (actions.rrp) {
    initColumn.push({
      field: "rrp",
      headerName: "RRP Sales",
      type: "number",
      align: "right",
      headerAlign: "right",
      minWidth: 120,
      valueFormatter: (value) => CurrencyFormat(value, 0),
    });
  }
  if (actions.scan) {
    initColumn.push({
      field: "scanSales",
      headerName: "Scan Sales",
      type: "number",
      align: "right",
      headerAlign: "right",
      minWidth: 120,
      valueFormatter: (value) => CurrencyFormat(value, 0),
    });
  }
  if (actions.margin) {
    initColumn.push({
      field: "margin",
      headerName: "Margin",
      type: "number",
      align: "right",
      headerAlign: "right",
      minWidth: 120,
      valueFormatter: (value) => CurrencyFormat(value, 0),
    });
  }
  if (actions.rebate) {
    initColumn.push(
      ...[
        {
          field: "tradeDiscount",
          headerName: "PD(Purchase)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => CurrencyFormat(value, 0),
        },
        {
          field: "promotionRebateTotal",
          headerName: "PD(Scan Sales)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 150,
          valueFormatter: (value) => CurrencyFormat(value, 0),
        },
      ]
    );
  }
  if (actions.rebate && actions.margin) {
    initColumn.push(
      ...[
        {
          field: "tradeDiscountToMargin",
          headerName: "PD(Purchase) (% of Margin)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => toPercent(value, 1),
          valueGetter: (value, row) => {
            return row.proportion.tradeDiscountToMargin;
          },
        },
        {
          field: "rebateToMargin",
          headerName: "PD(Scan Sales) (% of Margin)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 150,
          valueFormatter: (value) => toPercent(value, 1),
          valueGetter: (value, row) => {
            return row.proportion.rebateToMargin;
          },
        },
      ]
    );
  }
  if (_.every(actions)) {
    initColumn.push(
      ...[
        {
          field: "revenue",
          headerName: "Revenue",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,

          valueFormatter: (value) => CurrencyFormat(value, 0),
        },
        {
          field: "profit",
          headerName: "Profit",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => CurrencyFormat(value, 0),
        },
      ]
    );
  }
  if (actions.commission) {
    initColumn.push(
      ...[
        {
          field: "sumOfCommission",
          headerName: "P Comm.",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => CurrencyFormat(value, 0),
        },
        {
          field: "commissionToMargin",
          headerName: "P Comm. (% of Margin)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => toPercent(value, 1),
          valueGetter: (value, row) => {
            return row.proportion.commissionToMargin;
          },
        },
        {
          field: "commissionToScan",
          headerName: "P Comm. (% of Scan)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => toPercent(value, 1),
          valueGetter: (value, row) => {
            return row.proportion.commissionToScan;
          },
        },
      ]
    );
  }
  if (actions.marketing) {
    initColumn.push(
      ...[
        {
          field: "marketingTotalCost",
          headerName: "Mkt Cost",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => CurrencyFormat(value, 0),
        },
        {
          field: "marketingToMargin",
          headerName: "Mkt Cost (% of Margin)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => toPercent(value, 1),
          valueGetter: (value, row) => {
            return row.proportion.marketingToMargin;
          },
        },
        {
          field: "marketingToScan",
          headerName: "Mkt Cost. (% of Scan)",
          type: "number",
          align: "right",
          headerAlign: "right",
          minWidth: 120,
          valueFormatter: (value) => toPercent(value, 1),
          valueGetter: (value, row) => {
            return row.proportion.marketingToScan;
          },
        },
      ]
    );
  }

  const fetchData = async (
    brand_id = [],
    product_master_id = [],
    dateRanges,
    dateGrouping,
    typeGrouping,
    combineSameSku,
    areaGrouping
  ) => {
    try {
      setDataTableLoading(true);
      const { data } = await getProfitAndLoss(
        product_master_id,
        dateRanges[0][0],
        dateRanges[0][1],
        combineSameSku,
        typeGrouping
      );
      if (_.isArray(data)) {
        setRowData(data);
      } else {
        setRowData([data]);
      }
      let namecolumns = [];
      if (typeGrouping === "brand") {
        namecolumns = [
          {
            field: "brand_name",
            headerName: "Brand",
            minWidth: 120,
          },
        ];
      } else if (typeGrouping === "product") {
        namecolumns = [
          {
            field: "region_name",
            headerName: "Region",
            minWidth: 120,
          },
          {
            field: "mannings_product_code",
            headerName: "Mannings Code",
            minWidth: 120,
          },
          {
            field: "m18_product_code",
            headerName: "M18 Code",
            minWidth: 120,
          },
          {
            field: "product_name",
            headerName: "Product Name",
            minWidth: 200,
          },
        ];
      }
      const sortedColumn = _.sortBy(
        _.concat(namecolumns, initColumn),
        function (obj) {
          return _.indexOf(orders, obj.field);
        }
      );
      setColumns(sortedColumn);
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage(
        `發生錯誤 \n ${err.message} \n Message:${err.response.data.message}`
      );

      setSnackOpen(true);
    } finally {
      setDataTableLoading(false);
    }
  };
  const fetchProduct = async () => {
    const { data } = await getProducts();
    setProductData(data);
  };
  React.useEffect(() => {
    fetchProduct();
    if (searchParams.get("isShare")) {
      const params = {
        dateGrouping: searchParams.get("dateGrouping"),
        dateFilter: JSON.parse(searchParams.get("dateFilter")),
        selectedProduct: searchParams
          .get("selectedProduct")
          .split(",")
          .map((p) => parseInt(p)),
        typeGrouping: searchParams.get("typeGrouping"),
        combineSameSku: searchParams.get("combineSameSku"),
        selectedSource: searchParams.get("selectedSource").split(","),
        compareOption: searchParams.get("compareOption"),
        areaGrouping: searchParams.get("areaGrouping"),
      };
      dispatch(setFilter(params));
      fetchData(
        [],
        params.selectedProduct,
        [
          [
            moment(params.dateFilter.startDate1).format("YYYY-MM-DD"),
            moment(params.dateFilter.endDate1).format("YYYY-MM-DD"),
          ],
          [
            params.dateFilter.startDate2
              ? moment(params.dateFilter.startDate2).format("YYYY-MM-DD")
              : null,
            params.dateFilter.endDate2
              ? moment(params.dateFilter.endDate2).format("YYYY-MM-DD")
              : null,
          ],
        ],
        params.dateGrouping,
        params.typeGrouping,
        params.combineSameSku,
        params.areaGrouping,
        params.selectedSource
      );
      setSearchParams();
    }
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="ProfitAndLossTablePage"
      selectedIndex={3}
      open={open}
      snackClose={() => setSnackOpen(false)}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title title="Profit & Loss" />
      <Dialog
        maxWidth={"lg"}
        fullWidth
        open={detailDialogOpen}
        onClose={() => setDetailDialogOpen(false)}
      >
        <DialogContent>
          <ProfitAndLossDetailTable
            selectedDate={{
              startDate: dateFilter.startDate1,
              endDate: dateFilter.endDate1,
            }}
            data={selectedRow}
            defaultCollapseOpen={false}
          />
        </DialogContent>
      </Dialog>
      <Fade in={true} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <DataTable
            loading={dataTableLoading}
            onRowClick={({ row }) => {
              setDetailDialogOpen(true);
              setSelectedRow(row);
            }}
            rows={rowData}
            productData={productData}
            Toolbar={ProfitAndLossToolBar}
            columns={columns}
            noRowsLabel={"選擇篩選條件"}
            productSelecter={true}
            disableColumnSelector={true}
            disableColumnFilter={false}
            checkboxSelection={false}
            pinFirstColumn={false}
            searchBarPlaceholder={"搜尋產品"}
            pageSize={50}
            getRowId={getRowId}
            fetchData={fetchData}
          />
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default ProfitAndLossTablePage;
